// extracted by mini-css-extract-plugin
export default {"comment":"BlockCommentsField_comment__lQ0+c"};